import styled from 'styled-components';

import { theme } from '../layout/theme';

export const VideoWrapper = styled.div`
  max-width: ${theme.distances.containerMaxWidth};
  margin: 0 auto;
  width: 100%;
`;

export const VideoEmbed = styled.div`
  position: relative;
  height: 0;
  padding-bottom: 56.25%;
  margin: 0 auto;
`;

export const Iframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
